import { MarketPair, WalletType } from "@cede/types";
import { CEDE_CEXS } from "../cexs";
import { fixtures } from "./transactions";

export const isUsingMockedMarkets = (exchangeId: CEDE_CEXS, nodeEnv: string | undefined) => {
  if (nodeEnv === "test") return true;
  const mockedMarkets: CEDE_CEXS[] = [
    CEDE_CEXS.BINANCE,
    CEDE_CEXS.COINBASE,
    CEDE_CEXS.BYBIT,
    CEDE_CEXS.MEXC,
    CEDE_CEXS.OKX,
  ];
  return mockedMarkets.includes(exchangeId);
};

export const marketMock: MarketPair = {
  pairSymbol: fixtures.PAIR_SYMBOL,
  base: fixtures.DEFAULT_TX_SYMBOL_2,
  quote: fixtures.DEFAULT_TX_SYMBOL,
  maker: 0.001,
  taker: 0.001,
  active: true,
  type: WalletType.SPOT,
  precision: {
    amount: 8,
    price: 8,
    base: 8,
    quote: 8,
  },
  externalMarketId: fixtures.PAIR_SYMBOL,
};

// CCXT markets
// used in demo vault
export const markets = [
  {
    id: "BTCUSDT",
    lowercaseId: "btcusdt",
    symbol: "BTC/USDT",
    base: "BTC",
    quote: "USDT",
    baseId: "BTC",
    quoteId: "USDT",
    type: "spot",
    spot: true,
    margin: true,
    swap: false,
    future: false,
    option: false,
    active: true,
    contract: false,
    taker: 0.001,
    maker: 0.001,
    precision: { amount: 5, price: 2, base: 8, quote: 8 },
    limits: {
      leverage: {},
      amount: { min: 0.00001, max: 9000 },
      price: { min: 0.01, max: 1000000 },
      cost: { min: 10, max: 9000000 },
      market: { min: 0, max: 181.62522383 },
    },
  },
  {
    id: "ETHUSDT",
    lowercaseId: "ethusdt",
    symbol: "ETH/USDT",
    base: "ETH",
    quote: "USDT",
    baseId: "ETH",
    quoteId: "USDT",
    type: "spot",
    spot: true,
    margin: true,
    swap: false,
    future: false,
    option: false,
    active: true,
    contract: false,
    taker: 0.001,
    maker: 0.001,
    precision: { amount: 4, price: 2, base: 8, quote: 8 },
    limits: {
      leverage: {},
      amount: { min: 0.0001, max: 9000 },
      price: { min: 0.01, max: 1000000 },
      cost: { min: 10, max: 9000000 },
      market: { min: 0, max: 3995.9161675 },
    },
  },
  {
    id: "LINKUSDT",
    lowercaseId: "linkusdt",
    symbol: "LINK/USDT",
    base: "LINK",
    quote: "USDT",
    baseId: "LINK",
    quoteId: "USDT",
    type: "spot",
    spot: true,
    margin: true,
    swap: false,
    future: false,
    option: false,
    active: true,
    contract: false,
    taker: 0.001,
    maker: 0.001,
    precision: { amount: 2, price: 3, base: 8, quote: 8 },
    limits: {
      leverage: {},
      amount: { min: 0.01, max: 90000 },
      price: { min: 0.001, max: 10000 },
      cost: { min: 5, max: 9000000 },
      market: { min: 0, max: 85606.7175 },
    },
  },
  {
    id: "DOTUSDT",
    lowercaseId: "dotusdt",
    symbol: "DOT/USDT",
    base: "DOT",
    quote: "USDT",
    baseId: "DOT",
    quoteId: "USDT",
    type: "spot",
    spot: true,
    margin: true,
    swap: false,
    future: false,
    option: false,
    active: true,
    contract: false,
    taker: 0.001,
    maker: 0.001,
    precision: { amount: 2, price: 3, base: 8, quote: 8 },
    limits: {
      leverage: {},
      amount: { min: 0.01, max: 90000 },
      price: { min: 0.001, max: 10000 },
      cost: { min: 5, max: 9000000 },
      market: { min: 0, max: 97320.91608333 },
    },
  },
  {
    id: "BNBUSDT",
    lowercaseId: "bnbusdt",
    symbol: "BNB/USDT",
    base: "BNB",
    quote: "USDT",
    baseId: "BNB",
    quoteId: "USDT",
    type: "spot",
    spot: true,
    margin: true,
    swap: false,
    future: false,
    option: false,
    active: true,
    contract: false,
    taker: 0.001,
    maker: 0.001,
    precision: { amount: 3, price: 1, base: 8, quote: 8 },
    limits: {
      leverage: {},
      amount: { min: 0.001, max: 900000 },
      price: { min: 0.1, max: 100000 },
      cost: { min: 5, max: 9000000 },
      market: { min: 0, max: 11976.33799166 },
    },
  },

  {
    id: "AVAXUSDT",
    lowercaseId: "avaxusdt",
    symbol: "AVAX/USDT",
    base: "AVAX",
    quote: "USDT",
    baseId: "AVAX",
    quoteId: "USDT",
    type: "spot",
    spot: true,
    margin: true,
    swap: false,
    future: false,
    option: false,
    active: true,
    contract: false,
    taker: 0.001,
    maker: 0.001,
    precision: { amount: 2, price: 2, base: 8, quote: 8 },
    limits: {
      leverage: {},
      amount: { min: 0.01, max: 90000 },
      price: { min: 0.01, max: 10000 },
      cost: { min: 5, max: 9000000 },
      market: { min: 0, max: 56593.72483333 },
    },
  },
];
